import { render, staticRenderFns } from "./news-and-media-page.vue?vue&type=template&id=843c3832&scoped=true"
import script from "./news-and-media-page.vue?vue&type=script&lang=js"
export * from "./news-and-media-page.vue?vue&type=script&lang=js"
import style0 from "./news-and-media-page.vue?vue&type=style&index=0&id=843c3832&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "843c3832",
  null
  
)

export default component.exports